import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const RoundedModal = styled(Modal)`
    .modal-content {
        border-radius: 4px;
    }

    .modal-header,
    .modal-body,
    .modal-footer {
        position: relative;

        :first-child {
            border-radius: 4px 4px 0 0;
        }

        :last-child {
            border-radius: 0 0 4px 4px;
        }
    }

    .modal-header {
        background: ${({ theme }) => theme['gray-0']};
        color: ${({ theme }) => theme['gray-1000']};
        border-bottom: 1px solid ${({ theme }) => theme['gray-400']};

        .modal-title {
            color: ${({ theme }) => theme['gray-1000']};
        }
    }

    .modal-body {
        background: ${({ theme }) => theme['gray-100']};
        color: ${({ theme }) => theme['gray-1000']};
    }

    .modal-footer {
        button {
            border-radius: 3px;
        }
    }
`
